/**
 * Stores the passed in data in the local storage.
 * @param {String} queryString The query string to store
 */
const storeAttributionParams = queryString => {
  localStorage.setItem('attributionParams', queryString)
}

/**
 * Returns the stored attribution params or an empty string if none are stored.
 * @returns {String} The stored attribution params or an empty string if none are stored.
 */
const fetchAttributionParams = () => {
  return localStorage.getItem('attributionParams') || ''
}

export { storeAttributionParams, fetchAttributionParams }
